import useNativeListener from '@hooks/useNativeListener';
import { useFlow } from '@router/stackflow';
import { useActivity } from '@stackflow/react';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useAtom } from 'jotai';

function useAndroidBackButton() {
  const { pop, push } = useFlow();
  const [isSidebarOpen, setIsSidebarOpen] = useAtom(isSidebarOpenAtom);
  const { isTop } = useActivity();

  useNativeListener('onBackButtonClick', () => {
    if (isTop) {
      if (isSidebarOpen) {
        setIsSidebarOpen(false);
      } else {
        push('AppTerminationModal', {});
      }
    } else {
      pop();
    }
  }, [isSidebarOpen, isTop]);
}

export default useAndroidBackButton;
